import { render, staticRenderFns } from "./BankPayment.vue?vue&type=template&id=1d48003d&scoped=true&"
import script from "./BankPayment.vue?vue&type=script&lang=js&"
export * from "./BankPayment.vue?vue&type=script&lang=js&"
import style0 from "./BankPayment.vue?vue&type=style&index=0&id=1d48003d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d48003d",
  null
  
)

export default component.exports